/**
 * @author Theodore Kruczek
 * @license AGPL-3.0-or-later
 * @copyright (c) 2025 Kruczek Labs LLC
 *
 * Orbital Object ToolKit is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * Orbital Object ToolKit is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * Orbital Object ToolKit. If not, see <http://www.gnu.org/licenses/>.
 */
import { Vector } from '../main';
export class SimplexEntry {
    f_;
    points;
    score;
    x_;
    constructor(f_, points) {
        this.f_ = f_;
        this.points = points;
        this.x_ = new Vector(points);
        this.score = this.f_(points);
    }
    getPoints() {
        return this.x_.toArray();
    }
    getScore() {
        return this.score;
    }
    modify(n, xa, xb) {
        return new SimplexEntry(this.f_, this.x_.add(xa.x_.subtract(xb.x_).scale(n)).toArray());
    }
    distance(se) {
        return this.x_.distance(se.x_);
    }
}
